// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeploymentUnitOutlinedSvg from "@ant-design/icons-svg/es/asn/DeploymentUnitOutlined";
import AntdIcon from '../components/AntdIcon';

var DeploymentUnitOutlined = function DeploymentUnitOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeploymentUnitOutlinedSvg
  }));
};

DeploymentUnitOutlined.displayName = 'DeploymentUnitOutlined';
export default React.forwardRef(DeploymentUnitOutlined);